import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { SessionActions } from "../actions/guideStreamActions";

export default function queuedMentorReducer(state = initialState.queuedMentors, action: SessionActions) {
    switch (action.type) {
        case types.LOAD_QUEUED_MENTORS_SUCCESS:
            return action.queuedSessions;
        default:
            return state;
    }
}
